
<div class="loading-spinner" *ngIf="loading" role="alert">
    <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
    <div class="spinner">
        <div></div>
        <div></div>
    </div>
    <div class="loading-text">Loading..</div>
</div>
<div class="container">
    <h1>Authenticate Your Account</h1>
    <p>A 6-Digit authentication code has been sent to your email address. Please check and enter the code.</p>

    <div style="color: red" *ngIf="showEmailNotSendError">
            <b>Unable to send email, please try again.</b>
    </div>

    <div  *ngIf="!hideTokenValidity">
        <p><strong>Your Token is valid for {{this.validityText}}</strong></p>
    </div>
    <div  *ngIf="hideTokenValidity">
       
        <p>  <b>Your Token has expired, <a (click)="sendAuthenticationCode()" >click here</a> to send a new token.</b></p>
    </div>
    <div class="code-inputs">
        <input type="number" (paste)="onPaste($event)" (keyup.enter)="authenticateCode()" pattern="[0-9]*" min="0" max="9" maxlength="1" value="" inputtype="numeric" id="AuthToken1" required [(ngModel)]="authModel.AuthToken1" (keyup)="onDigitInput($event)" (keypress)="numberOnly($event)" (keydown)="disableArrowKeys($event)" />
        <input type="number" (paste)="onPaste($event)" (keyup.enter)="authenticateCode()" pattern="[0-9]*" min="0" max="9" maxlength="1" value="" inputtype="numeric" id="AuthToken2" required [(ngModel)]="authModel.AuthToken2" (keyup)="onDigitInput($event)" (keypress)="numberOnly($event)" (keydown)="disableArrowKeys($event)" />
        <input type="number" (paste)="onPaste($event)" (keyup.enter)="authenticateCode()" pattern="[0-9]*" min="0" max="9" maxlength="1" value="" inputtype="numeric" id="AuthToken3" required [(ngModel)]="authModel.AuthToken3" (keyup)="onDigitInput($event)" (keypress)="numberOnly($event)" (keydown)="disableArrowKeys($event)" />
        <input type="number" (paste)="onPaste($event)" (keyup.enter)="authenticateCode()" pattern="[0-9]*" min="0" max="9" maxlength="1" value="" inputtype="numeric" id="AuthToken4" required [(ngModel)]="authModel.AuthToken4" (keyup)="onDigitInput($event)" (keypress)="numberOnly($event)" (keydown)="disableArrowKeys($event)" />
        <input type="number" (paste)="onPaste($event)" (keyup.enter)="authenticateCode()" pattern="[0-9]*" min="0" max="9" maxlength="1" value="" inputtype="numeric" id="AuthToken5" required [(ngModel)]="authModel.AuthToken5" (keyup)="onDigitInput($event)" (keypress)="numberOnly($event)" (keydown)="disableArrowKeys($event)" />
        <input type="number" (paste)="onPaste($event)" (keyup.enter)="authenticateCode()" pattern="[0-9]*" min="0" max="9" maxlength="1" value="" inputtype="numeric" id="AuthToken6" required [(ngModel)]="authModel.AuthToken6" (keyup)="onDigitInput($event)" (keypress)="numberOnly($event)" (keydown)="disableArrowKeys($event)" />
    </div>
    <div style="color: red" *ngIf="isAuthCodeEmpty">
        <p>
            Please enter authentication code.
        </p>
    </div>
    <div style="color: red" *ngIf="invalidTokenError">
        <p>
            Incorrect Token, please try again.
        </p>
    </div>
    <p>
        Did not receive the token?
        <a (click)="sendAuthenticationCode()">Click here</a> to send a new token.
    </p>

    <button  [ngClass]="{'authenticateneje-btn':isNeje,'authenticatessi-btn':!isNeje}" (click)="authenticateCode()">Authenticate</button>
</div>
